import { useI18n } from "@core/i18n/i18n";
import { DialogContext } from "@ui/components/dialog/dialog-provider";
import { ConfirmActionDialog } from "@ui/pages/program-builder/dialog/confirm-dialog";
import { DialogProps } from "primereact/dialog";
import React, { useCallback, useContext } from "react";

export interface ConfirmDuplicationDialogProps extends DialogProps {
	onConfirm?: () => void;
	onCancel?: () => void;
}

export const ConfirmDuplicationDialog = ({
	onConfirm,
	onCancel,
	...otherProps
}: ConfirmDuplicationDialogProps): JSX.Element => {
	const { format } = useI18n();
	const dialogContext = useContext(DialogContext);

	const handleConfirm = useCallback(() => {
		onConfirm?.();
		dialogContext?.closeAll();
	}, [dialogContext, onConfirm]);

	const handleCancel = useCallback(() => {
		onCancel?.();
		dialogContext?.closeAll();
	}, [dialogContext, onCancel]);

	return (
		<ConfirmActionDialog
			{...otherProps}
			onConfirm={handleConfirm}
			onCancel={handleCancel}
			title={format("global.confirmDuplicationDialog.title")}
			confirmButtonLabel={format("global.confirmDuplicationDialog.confirmButtonLabel")}
			message={format("global.confirmDuplicationDialog.message")}
		/>
	);
};
